import $ from "jquery";

(function () {
  $('.burger').click(function () {
    $('.nav-main').addClass('active')
    $('body').addClass('lock')
    $('html').addClass('lock')
    $(this).addClass('open')
  })
  $('.nav-main .close-menu , .nav-main .after').click(function () {
    $('.nav-main').removeClass('active')
    $('body').removeClass('lock')
    $('html').removeClass('lock')
    $('.burger').removeClass('open')
  })

  function stickyHeader() {
    if ($(window).scrollTop() > 0) {
      $('header').addClass('header-fixed');
    } else {
      $('header').removeClass('header-fixed');
    }
  }

  $(window).scroll(stickyHeader)
  $(document).ready(stickyHeader)
})()

function addActiveLink() {
  const links = $('.header-menu a');
  links.each(function () {
    const href = $(this).attr('href');
    if (  href.charAt(0) !== "#" && href !== undefined && href !== '/' && window.location.href.match(href)) {
      $(this).parent().addClass('active')
    }
  });
}
addActiveLink()